<template>
    <div class="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-neutral-100 p-4">
        <slot />
    </div>
</template>
